import React, { FC, ReactElement, MouseEvent } from 'react'
import { onKeyboardClick } from '@/utils/a11y/keyboard-click'

const NFTIcon: FC<{
	className?: string
	width?: number
	height?: number
	onClick?: (evt: MouseEvent) => void
}> = (props): ReactElement => {
	return (
		<svg
			onClick={props.onClick}
			viewBox="0 0 20 20"
			fill="none"
			className={props.className}
			width={props.width}
			height={props.height}
			role={props.onClick ? "button" : undefined}
			tabIndex={props.onClick ? 0 : undefined}
			onKeyDown={onKeyboardClick(props.onClick)}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3 2.73C1.34 2.73 0 4.07 0 5.73V14.27C0 15.93 1.34 17.27 3 17.27H17C18.66 17.27 20 15.93 20 14.27V5.73C20 4.07 18.66 2.73 17 2.73H3ZM7.78 13.64V6.36H6.42V10.54L5.01 6.36H3.64V13.64H5V9.24L6.48 13.64H7.78ZM10.29 13.64V10.54H12.03V9.33H10.29V7.57H12.11V6.36H8.92V13.64H10.29ZM15.13 7.57V13.64H13.75V7.57H12.65V6.36H16.23V7.57H15.13Z"
				fill="white"
			/>
		</svg>
	)
}

export default NFTIcon
